module.exports = {"title":"GoGoVan快遞APP - 網頁下單 | GoGoVan 台灣","meta":{"description":"GoGoVan快遞APP - 網頁下單, 全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊，當日配送沒問題。"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/template_for_angular/locale.json
// module id = 754
// module chunks = 0 1 2 3 4 5